<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BT30Wd/tc-custom/9781597482134.jpg?1693542448991" alt="This image is the cover for the book The Scare Crow, The Inner Circle:  A Hidden Falls Spin-off"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Scare Crow, The Inner Circle:  A Hidden Falls Spin-off
      </h1>
      <p class="bookDescription body article font2">
        <p>If you like 365 Days, and After, you'll love the steamy romances from Kailin Gow like this one.  My Code Name is The Scare Crow, and I am part of the Inner Circle, the most Secret of Secret Societies. Parker James killed my father, one of the founders and kingpins in the Inner Circle. Now as an Offspring of a Founder, I was groomed to replace my father in the Inner Circle, and trained to be an assassin will seek revenge. I am known as the Scare Crow. Perfect for Parker James. Having the Scare Crow after him will get him closer to Oz. But now the other players, including Dorothy, The Wizard, and the Lion's coming out to play, too. **The Inner Circle Series is a Dark College Romance Thriller with lots of action, steamy scenes, language, and twists and turns. Recommended for age 18 and up.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kailin Gow
      </h2>
      
      <p class="authorDescription body article">Kailin Gow is a million-selling author who has written and published close to 700 books under her name and various pen names in multiple genres since 2001. She is also an award-winning filmmaker whose films has screened all over the world including Cannes, Los Angeles, London, Paris, Japan, Korea, India, Germany, and Greece. Her books Bitter Frost and PULSE Vampires have been made into video games and is currently filming as featured films. She has been named as the most prolific Asian American author, and has been quoted as the representative for AAPI Heritage Week. Currently, two of her book series, Red Genesis, co-written by Kira G. and her science fiction romance series FADE have been optioned by the Netflix Top 2 Overall film production company Wish Dragon. She is set to write and direct the AAPI diverse cast featured film of Jane Austen’s Pride and Prejudice.  As an actress, she is currently in pre-production to star in 4 AAPI-led films, including her enemies-to-lover novel based on her relative’s ramen factory called Ramen Romance and her real-life experience as an author who has organized some of the biggest book signing events in her novel Love Letters from Las Vegas.  Go to KailinGow.com tfor updates and news.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sparklesoup.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b6fec65